import { useState, useEffect } from "react";
import { getPackages } from "@/lib/api";
import { logWarn } from "@/lib/log";

export const naira = (n) => `₦${Number(n).toLocaleString()}`;

export const creditsToTime = (credits) => {
    const seconds = Math.max(Math.floor((credits || 0) / 2), 0);
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return m > 0 ? `${m}m ${s}s` : `${s}s`;
};

const PlanCard = ({ p, ctaLabel, onSelect }) => (
    <div
        className={`border bg-surface p-6 flex flex-col ${
            p.id === "pro" ? "border-blaze" : "border-white/10"
        }`}
        data-testid={`pricing-card-${p.id}`}
    >
        {p.id === "pro" && (
            <div className="font-mono text-[9px] uppercase tracking-[0.3em] text-blaze mb-3">
                ● Most Popular
            </div>
        )}
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">{p.name}</div>
        <div className="font-display font-bold text-3xl mt-3">{naira(p.price_ngn)}</div>
        <div className="mt-4 space-y-2 font-mono text-xs text-white/60 flex-1">
            <div>
                <span className="text-white font-bold">{p.credits.toLocaleString()}</span> credits
            </div>
            <div>≈ {creditsToTime(p.credits)} of live streaming</div>
            <div>OBS integration included</div>
            <div>Unlimited style swaps</div>
        </div>
        <button
            onClick={() => onSelect?.(p)}
            className={`mt-6 w-full font-mono uppercase text-[11px] tracking-[0.2em] py-3 transition-colors ${
                p.id === "pro"
                    ? "bg-blaze hover:bg-blazeHover text-white"
                    : "bg-transparent border border-white/20 hover:border-white/60 text-white"
            }`}
            data-testid={`pricing-cta-${p.id}`}
        >
            {ctaLabel}
        </button>
    </div>
);

export const PricingSection = ({ onSelect, ctaLabel = "Create Account" }) => {
    const [packages, setPackages] = useState([]);

    useEffect(() => {
        getPackages().then(setPackages).catch((e) => logWarn("packages load failed", e));
    }, []);

    return (
        <section id="pricing" className="max-w-[1600px] mx-auto px-6 lg:px-10 py-16" data-testid="pricing-section">
            <div className="flex items-baseline justify-between flex-wrap gap-3 mb-10">
                <div>
                    <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-blaze">/ Pricing</div>
                    <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl mt-2 tracking-tight">
                        Pay for what you stream
                    </h2>
                </div>
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40 max-w-md">
                    2 credits per second of live transformation. Top up anytime.
                </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {packages.map((p) => (
                    <PlanCard key={p.id} p={p} ctaLabel={ctaLabel} onSelect={onSelect} />
                ))}
            </div>
        </section>
    );
};
